<script>
import RegionApi from "../../../api/RegionApi";
import {Listeners} from "../../../constants/listeners";

export default {
    data: () => ({
        regions: null,
    }),
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },
        async loadRegionsList() {
            const regionsList = await RegionApi.getRegionsList();

            this.regions = regionsList.map(region => ({
                value :region.value,
                label :region.label,
            }));
        },
    },
    async created() {
        await this.loadRegionsList();

        if (!this.item.value.length && this.items && this.items.length > 0) {
            this.item.value.push(this.items[0].value)
        }
    },
}
</script>
<template>
    <select class="fieldselect" v-model="item.value" multiple size="5">
        <option v-for="v in regions" v-bind:value="v.value" v-text="v.label"></option>
    </select>
</template>
